import { PREFIX_CLS, THEME_COLOR_LIST } from '../../../common/constants';
import './style.less';
import { MsgDataType } from '../../../common/type';
import { formatByDataFormatType, getFormattedValue } from '../../../utils/utils';
import type { ECharts } from 'echarts';
import * as echarts from 'echarts';
import { useEffect, useRef, useState, useContext } from 'react';
import { ColumnType } from '../../../common/type';
import { useExportByEcharts } from '../../../hooks';
import { ChartItemContext } from '../../ChatItem';
type Props = {
  data: MsgDataType;
  metricField: ColumnType;
  categoryField: ColumnType;
  triggerResize?: boolean;
  question?: string;
};

const LineChart: React.FC<Props> = ({
  data,
  metricField,
  categoryField,
  triggerResize,
  question = ""
}) => {
  const chartRef = useRef<any>();
  const instanceRef = useRef<ECharts>();
  const [Value, setValue] = useState('');
  const { queryResults } = data;
  const categoryColumnName = categoryField?.bizName || '';
  const metricColumnName = metricField?.bizName || '';
  const { downloadChartAsImage } = useExportByEcharts({
    instanceRef,
    question,
  });
  const { register } = useContext(ChartItemContext);
  const renderChart = () => {
    let instanceObj: any;
    if (!instanceRef.current) {
      instanceObj = echarts.init(chartRef.current);
      instanceRef.current = instanceObj;
    } else {
      instanceObj = instanceRef.current;
    }

    const data = queryResults || [];
    const xData = data.map(item => item[categoryColumnName] !== undefined ? item[categoryColumnName] : '未知');
    const yData = data.map(item => item[metricColumnName]);

    instanceObj.setOption({
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          const value = params[0].value;
          return `${params[0].name}: ${metricField.dataFormatType === 'percent'
            ? formatByDataFormatType(value, metricField.dataFormatType, metricField.dataFormat)
            : getFormattedValue(value)
            }`;
        },
      },
      legend: {
        orient: 'vertical',
        right: 'right',
        top: 'center',
        type: 'scroll',
        data: [metricField.bizName].filter(name => name !== null && name !== undefined)
      },
      xAxis: {
        type: 'category',
        data: xData,
        axisLabel: {
          overflow: 'truncate',
          showMaxLabel: true,
          hideOverlap: true,
          interval: 'auto', // 文本标签过密 'auto'
          rotate: 50, // 倾斜显示
          formatter: function (value: string) {
            return value.substring(0, 8); // 截断日期，如 "2025-06-24"
          },
        },
      },
      scrollbar: {
        show: true,
        type: 'horizontal'
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: function (value: any) {
            if (typeof value === 'number') {
              return Number(value).toFixed(2);
            }
            return '';
          }
        }
      },
      series: [{
        name: metricField.bizName,
        type: 'line',
        data: yData,
        showSymbol: true,
        symbolSize: 6,
        smooth: true,
        label: {
          show: true,
          position: 'top',
          formatter: '{c}'
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, 0.3)'
          },
          label: {
            show: true
          }
        }
      }],
      graphic: {
        elements: [{
          type: 'text',
          right: 10,
          bottom: 5,
          z: 100,
          style: {
            text: '内容由AI生成',
            fontSize: 12,
            fontWeight: 'normal',
            fill: 'rgba(0, 0, 0, 0.45)'
          }
        }]
      },
    });
    instanceObj.resize();
  };

  useEffect(() => {
    if (queryResults && queryResults.length > 0) {
      renderChart();
    }
  }, [queryResults, metricField, categoryField]);

  useEffect(() => {
    if (triggerResize && instanceRef.current) {
      instanceRef.current.resize();
    }
  }, [triggerResize]);
  register('downloadChartAsImage', downloadChartAsImage);
  return <div className={`${PREFIX_CLS}-line-chart`} ref={chartRef} />;
};

export default LineChart;